import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=3b9ffb8d&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=3b9ffb8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9ffb8d",
  null
  
)

export default component.exports